export const ModalState = {
  DEFAULT: 'DEFAULT',
  BOT: 'BOT',
  AFFORD: 'AFFORD',
  ITEMS: 'ITEMS'
};
